import { ErrorTemplateBuilder } from '../../infrastructure/error-template-builder';
import { CxAppSettingsService } from './cx-app-settings-service';

export class SignalRCxAppSettingsService {
    
    public setCxAppBrandingConnectionEvents(connection: signalR.HubConnection) {
        connection.on("CxAppBranding", async (message: any) => {
            try {
                await CxAppSettingsService.load();
            } catch (e) {
                console.error(ErrorTemplateBuilder.getCatchText('SignalRCxAppSettingsService.CxAppBranding', e));
            }
        });
    }
}
